import { Component, OnInit, Renderer2,EventEmitter, DestroyRef, inject } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { HubConnection } from '@microsoft/signalr';

import {
  DEFAULT_USERNAME,
  INVOICE_PAYMENT_STATUS_UPDATE,
  NO_IMAGE,
  USER_ROLES,
  USER_TYPE,
} from '../../constant/shared.constant';
import { LayoutService } from '../../services/layout.service';
import { AuthService } from '@core/services/auth.service';

import { SignalRService } from '../../services/signal-r.service';
import { environment } from 'src/environments/environment';
import {
  GetNotificationRequest,
  NotificationResponse,
  PushNotification,
  UpdateNotificationRequest,
} from '@core/models/push-notification.model';
import { autoUnsubWith, Utility } from '../../services/utility.abstract';
import { ManagerDetail } from '@core/models/manager-details.model';
import { Router } from '@angular/router';
import { CompanyService } from '../../services/company.service';
import { NotificationStatus, ParkingLot } from '@core/models/api-response.model';
import { MenuItem } from 'primeng/api';
import { SuperAdminService } from '@core/services/super-admin.service';
import { OwnerListComponent } from '@modules/super-admin/components/owner-list/owner-list.component';
import { ResetPasswordModalComponent } from '../reset-password-modal/reset-password-modal.component';
import { DialogControlService } from '../../services/dialog-control.service';
import { CommonMenuService } from '@shared/services/common-util.service';
import { ReloadService } from '@shared/services/reload.service';
import { CommonFunctions } from '@shared/common-functions';
import { ToastService } from '@shared/services/toast.service';
import { CompanyDetailsService } from '@core/services/company-details.service';
import { ProfileService } from '@core/services/profile.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
const baseURL = environment.notificationEndPoint;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  imagePath = NO_IMAGE;
  userName = DEFAULT_USERNAME;
  bookingId: string;
  notificationRecord: PushNotification[] = [];
  totalNotifications = 0;
  noticationData: EventEmitter<string> = new EventEmitter<string>();
  parkingLotByStates: ParkingLot[];
  private _hubConnection: HubConnection | undefined;
  role: string;
  editIcon: string = '../../../../assets/images/sidebar_svg/profile.svg';
  selectedOption: string;
  id: string;
  selectedParkingLot: string;
  companyName: string;
  companyLogo: string;
  showNotifications: boolean = false;
  parkingCount: number;
  showCompanyText: boolean = false;
  breadcrumbText: string;
  url: string;
  items: MenuItem[] | undefined;
  isGuestUser: string;
  isSmallScreen: boolean = false;
  isSidebarOpen: boolean;
  isSidebarHovered = false;
  userRoles = USER_ROLES;
  userType = USER_TYPE
  roleRoute: string;
  notificationStatus = NotificationStatus;
  pageNumber:number = 1;
  isLoading:boolean = false;
  isAllNotificationLoaded: boolean = false;
  constructor(
    private readonly service: ProfileService,
    private readonly authService: AuthService,
    private readonly signalRService: SignalRService,
    private readonly dialogControlService: DialogControlService,
    private readonly layoutService: LayoutService,
    private readonly companyService: CompanyService,
    private readonly companyDetailservice: CompanyDetailsService,
    private readonly superAdminService: SuperAdminService,
    private readonly renderer: Renderer2,
    private readonly router: Router,
    private readonly commonMenuService: CommonMenuService,
    private readonly reloadService: ReloadService,
    private readonly toastService: ToastService,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit(): void {
    this.layoutService.isSmallScreen$.subscribe((isSmall: boolean) => {
      this.isSmallScreen = isSmall;
      this.isSidebarOpen = this.layoutService.isSidebarOpen;
    });
    this.layoutService.isSidebarHovered$.subscribe((isHovered: boolean) => {
      this.isSidebarHovered = isHovered;
    });
    this.isGuestUser = this.encryptStorage.getItem('isGuestUser');
    const currentUrl = this.router.url;
    const isGuestBookingRoute = (
      currentUrl.includes('guest/booking') ||
      currentUrl.includes('guest/transflow-booking') ||
      currentUrl.includes('guest/transflow-create-booking')
    );

    if (!this.isGuestUser && !isGuestBookingRoute) {
      this.profileImageChange();
      this.getUserById();
      this.startHubConnection();
      this.getNotificationsByUserId();
    }
    this.role = this.encryptStorage.getItem('roleName');
    if (
      this.role == this.userRoles.SUPER_ADMIN ||
      this.role === this.userRoles.GROUP_USER
    ) {
      this.companyService.getAdminHeaders()
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe((res) => {
        if (res.companyId !== '0' && res.companyId !== null) {
          this.companyName = this.encryptStorage.getItem('companyName');
          this.showCompanyText = true;
        } else {
          this.showCompanyText = false;
        }
        if (res.breadcrumb != null) {
          const breadcrumbText1: any = res.breadcrumb;
          this.breadcrumbText = breadcrumbText1
            .map((item) => {
              if (item.url) {
                return `<a href="${item.url}" class="${item.class || ''}">${
                  item.title
                }</a>`;
              } else {
                return item.title;
              }
            })
            .join(` <span class="circle-icon">&#9679</span> `);
        }
      });
    }
    if (this.role !== this.userRoles.DRIVER) {
      this.url = 'manager/user/profile';
    }
    if (
      this.role === this.userRoles.PARKING_OWNER ||
      this.role === this.userRoles.PARKING_MANAGER
    ) {
      this.getCompanyDetails();
    } else {
      this.url = 'manager/profile';
    }
  }

  getUserById() {
    this.service.getUserById(this.authService.getUserId())
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: ManagerDetail) => {
        if (response.profileImagePath) {
          this.imagePath = response.profileImagePath;
        }
        if (response.name) {
          if (response.name === this.userRoles.SUPER_ADMIN) {
            this.userName = this.transformText(response.name);
          } else {
            this.userName = response.name;
          }
        }
      },
    });
  }

  transformText(text: string): string {
    return text.replace(/([A-Z])/g, ' $1').trim();
  }

  toggleSidebar() {
    this.layoutService.toggleSidebar();
    this.isSidebarOpen = this.layoutService.isSidebarOpen;
  }

  getNotificationsByUserId() {
    this.isLoading = true;
    const getNoficationReq: GetNotificationRequest = {
      isWebPortal: true,
      timeZone: Utility.getLocalTimeZone(),
      pageNumber: this.pageNumber,
      pageSize: 10,
    };
    const customHeaders = { 'isLoaderStop': 'true'};
    this.service.getNotificationsByUserId(getNoficationReq, customHeaders)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: NotificationResponse) => {
        if (res.notifications?.length) {
          this.notificationRecord = [...this.notificationRecord, ...res.notifications];
          this.pageNumber++;
          this.isLoading = false;
        }
        this.totalNotifications = res.unreadCount;
      },
      error: () => {
        this.isAllNotificationLoaded = true;  
        if (this.notificationRecord.length === 0) {
          this.notificationRecord = [];
          this.totalNotifications = 0;
        }
        this.isLoading = false;
      },
    });
  }

  onScroll(event: any) {
    const element = event.target;
    if (this.isLoading || this.isAllNotificationLoaded) {
      return;
    }
    // Check if scrolled to bottom
    const atBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 10;
    if (atBottom) {
      this.isLoading = true; // Set loading flag before API call
      this.getNotificationsByUserId();
    }
  }

  handleNotificationClick(notification: PushNotification) {
    this.isAllNotificationLoaded = false;
    if (this.role == this.userRoles.DRIVER || this.role == this.userRoles.GROUP_USER) {
      this.updateNotificationReadStatus(notification.id);

      return;
    }

    if (notification.subject === 'Parking Space Full') {
      this.router.navigateByUrl('manager/parking');
      this.showHideNotificationList();
    } else {
      this.updateNotificationReadStatus(notification.id);
      this.handleNotificationByStatus(notification);
    }
  }

  private isAdminRole(): boolean {
    return [
      this.userRoles.SUPER_ADMIN,
      this.userRoles.PARKING_MANAGER,
      this.userRoles.PARKING_OWNER,
    ].includes(this.role);
  }

  private navigateTo(route: string, queryParams: any = {}): void {
    this.router.navigate([`${this.roleRoute}/${route}`], { queryParams }).then(() => {
      this.superAdminService.triggerPopupClose(true);
    });
  }

  handleNotificationByStatus(notification: any): void {
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
    let shouldCallShowHide = false; // Flag to track if any case executes
  
    switch (notification.notificationStatus) {
      case this.notificationStatus.BookingNotification:
        if (this.isAdminRole()) {
          const route =
            notification.userType === this.userType.DRIVER
              ? 'booking-details'
              : 'group-booking-details';
          this.navigateTo(route, { id: notification.bookingId, assisted: false });
          shouldCallShowHide = true;
        }
        break;
  
      case this.notificationStatus.PaymentSuccessful:
        if (this.isAdminRole()) {
          if (notification.bookingId) {
            const route =
              notification.userType === this.userType.DRIVER
                ? 'booking-details'
                : 'group-booking-details';
            this.navigateTo(route, { id: notification.bookingId, assisted: false });
          } else if (notification.customInvoiceId) {
            const isGroupOperator = notification.userType === this.userType.GROUP_OPERATOR;
            this.navigateTo(isGroupOperator ? 'group-operator-info' : 'driver-info', {
              [isGroupOperator ? 'Id' : 'id']: notification.bookingCustomInvoiceUserId,
              tab: 2,
              iTab: 0,
            });
          }
          shouldCallShowHide = true;
        }
        break;
  
      case this.notificationStatus.CustomInvoiceNotification:
      case this.notificationStatus.CustomInvoicePaymentReminder:
        if (this.isAdminRole()) {
          const isGroupOperator = notification.userType === this.userType.GROUP_OPERATOR;
          this.navigateTo(isGroupOperator ? 'group-operator-info' : 'driver-info', {
            [isGroupOperator ? 'Id' : 'id']: notification.bookingCustomInvoiceUserId,
            tab: 2,
            iTab: 0,
          });
          shouldCallShowHide = true;
        }
        break;
  
      case this.notificationStatus.MessageNotification:
        if (this.isAdminRole()) {
          CommonFunctions.navigateToMessageRoute(notification.bookingId, this.role, this.router);
          shouldCallShowHide = true;
          this.superAdminService.triggerPopupClose(true); // Emit event to refresh list
        }
        break;
    }
  
    // Call showHideNotificationList() only if a case was executed
    if (shouldCallShowHide) {
      this.showHideNotificationList();
    }
  }  

  updateNotificationReadStatus(_id: any) {
    this.pageNumber = 1;
    this.notificationRecord = [];
    
    const updateNotificationRequest: UpdateNotificationRequest = {
      notificationId: _id,
    };
    this.service
      .updateNotificationReadStatus(updateNotificationRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: ({ message }) => {
          this.getNotificationsByUserId();
          
          this.toastService.showToastMessage('success', 'Success', message);
        }, error: ({ error }) => {
          
          this.toastService.showToastMessage('error', 'Error', error?.message);
        }
      });
  }

  profileImageChange(): void {
    this.service
      .getProfileData()
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe((profileData: { name: string; img: string }) => {
        if (profileData.name) {
          this.userName = profileData.name;
        }
        if (profileData.img) {
          this.imagePath = profileData.img;
        }
      });
  }

  showHideNotificationList(): void {
    this.showNotifications = !this.showNotifications;
     this.isShowNotificationHide();
  }

  private startHubConnection() {
    const options = {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    };

    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(baseURL, options)
      .withAutomaticReconnect()
      .build();

    this._hubConnection!.start()
      .then(() => {})
      .catch(() => {});

    this._hubConnection!.on(
      'BroadcastMessage',
      (userId: string, _type: string, _payload: string) => {
        if (userId == this.authService.getUserId()) {
          if (_type === INVOICE_PAYMENT_STATUS_UPDATE) {
            this.reloadService.triggerReload();
          }
          this.signalRService.setNotificationTrigger();
          this.getNotificationsByUserId();
        }
      }
    );
  }

  closeNotificationOnOutSideClick(): void {
    if (this.showNotifications) {
      this.showNotifications = false;
      this.isShowNotificationHide(); // Call only when it was open
    }
  }

  isShowNotificationHide() {
    if (this.notificationRecord.length > 0) {
      this.isAllNotificationLoaded = false;
      this.pageNumber = 1;
      this.notificationRecord = [];
      this.getNotificationsByUserId();
    }
  }

  getParkingLotByStatesName(id) {
    this.superAdminService.getParkingLotByStatesName(id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: ParkingLot[]) => {
        this.parkingCount = response.length;
        response.unshift({
          id: '1',
          name: `All Parking Lots (${this.parkingCount})`,
        });
        this.selectedParkingLot = response[0].id;
        this.parkingLotByStates = response;
      },
    });
  }

  openCompanyListModal() {
    this.dialogControlService.openDialog(OwnerListComponent, {
      width: '90%',
      height: '100%',
      closable: false,
      data:{
        onCompanyChange: true
      }
    });
  }

  showData() {
    const actionMap = {
      myProfile: () => {
        this.router.navigateByUrl(this.navigateProfileByRole());
      },
      changePassword: () => {
        this.openResetPasswordModal();
      },
      logout: () => {
        this.logout();
      },
    };

    let config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'My Profile',
        icon: 'pi pi-user-edit',
        escape: false,
        styleClass: 'my-profile',
        command: actionMap.myProfile,
      },
      {
        label: 'Change Password',
        icon: 'pi pi-unlock',
        escape: false,
        command: actionMap.changePassword,
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: actionMap.logout,
      },
    ];
    if (this.role === this.userRoles.SUPER_ADMIN) {
      config = config.filter((item) => item.label !== 'My Profile');
    }

    this.items = this.commonMenuService.commonShowData(config);
    this.showNotifications = false;
  }

  navigateProfileByRole(): string {
    const roleToUrlMap = {
      Driver: 'driver/profile',
      ParkingManager: 'manager/user/profile',
      ParkingOwner: 'manager/user/profile',
      GroupUser: 'group-operator/profile',
    };
    const profileUrl = roleToUrlMap[this.role];
    this.router.navigateByUrl(profileUrl).catch(() => {
    });
    return profileUrl;
  }

  openResetPasswordModal() {
    this.dialogControlService.openDialog(ResetPasswordModalComponent, {
      width: '35%',
    });
  }

  logout(): void {
    if (this.isSmallScreen) {
      this.layoutService.closeSidebar();
    }
    this.router.events.subscribe(() => {
      this.renderer.removeClass(document.body, 'logged-in');
    });
    localStorage.clear();
    this.router.navigateByUrl('login');
  }

  getCompanyDetails() {
    this.companyDetailservice.getCompanyDetails()
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.companyLogo = response.companyLogoPath;
      },
    });
  }
}
